import { render } from "./OutboundCallsChart.vue?vue&type=template&id=0ba14e04&ts=true"
import script from "./OutboundCallsChart.vue?vue&type=script&lang=ts"
export * from "./OutboundCallsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__